import { useEffect, useState } from 'react';
import debounce from 'lodash-es/debounce';

export interface WindowArea {
  // 실제 영역이 불일치할 수 있는 모바일 환경을 위한 크기 값
  width?: number;
  height?: number;
  // 내부 영역 절댓값
  actualWidth?: number;
  actualHeight?: number;
}

const POLLING_RATE = 15;

const getWindowInfo = (): WindowArea | undefined => {
  if (typeof window === 'undefined') return undefined;

  return {
    width: document.body?.clientWidth || window.innerWidth || window.screen?.availWidth,
    height: document.body?.clientHeight || window.innerHeight || window.screen?.availHeight,
    actualWidth: window.innerWidth,
    actualHeight: window.innerHeight,
  };
};

export default function useWindow() {
  const [windowInfo, setWindowInfo] = useState<WindowArea | undefined>(getWindowInfo);

  useEffect(() => {
    const handleResize = () => setWindowInfo(getWindowInfo());
    const debouncedResize = debounce(handleResize, POLLING_RATE);

    window.addEventListener('resize', debouncedResize);

    return () => {
      window.removeEventListener('resize', debouncedResize);
      debouncedResize.cancel();
    };
  }, []);

  return windowInfo;
}
